/**
 * buildQuery — the one place list hooks turn a params object into a
 * query string (assessment C9 / gap: ~41 hand-rolled `URLSearchParams`
 * blocks across 24 files, each 8–12 lines of `if (q?.x) sp.set(...)`).
 *
 * Semantics chosen to match the existing hooks and the API's Zod
 * schemas exactly:
 *   - `undefined` / `null` / `""` are omitted (unset).
 *   - `false` is omitted too — the list APIs use `z.coerce.boolean()`,
 *     which treats ANY non-empty string (including "false") as true, so
 *     a boolean flag is presence-based: only `true` is serialized.
 *   - numbers and `true` are stringified.
 *
 * Returns the leading `?` when non-empty, or `""` — so call sites read
 * `apiFetch(`/contacts${buildQuery(query)}`, ...)`.
 */
export function buildQuery(
  params?: Record<string, string | number | boolean | undefined | null>,
): string {
  if (!params) return "";
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "" || value === false) continue;
    sp.set(key, String(value));
  }
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
}
